import axios from 'axios';

export const updateCompanySector = async (companyId, sectorId) => {
  const { data } = await axios.put(`/company/${companyId}/sector/${sectorId}`);

  return data;
};
